import React,{useState} from 'react'
import "./tindercards.css"
import TinderCard from 'react-tinder-card'
function TinderCards() {
    const[people,setPeople]=useState([{
        name : 'Name 1',
        url : 'https://source.unsplash.com/random',
    },
    {
        name : 'name2',
        url : 'https://source.unsplash.com/random',
    }
]);

    
const swiped =(direction,nameToDelete)=>{
    console.log ("removing:" + nameToDelete)
}
const outOfFrame =(name) =>{
    console.log(name+ "Left of the screen !")
}
    
    return (
        <div className="TinderCards">
            <div className="tindercards__cardcontainer">

            {people.map((person)=>(
                <TinderCard
                className="swipe"
                key={person.name}
                preventSwipe={["up","down"]}
                onSwipe={(dir)=> swiped(dir,person.name)}
                onCardLeftScreen={()=>outOfFrame(person.name)}
                >
                <div className="card"
                style={{backgroundImage :`url (${person.url})`}} >
                                 
                          <h3>{person.name}</h3>
                </div>

                </TinderCard>
               
               ))}
               </div>
        </div>
    )
}

export default TinderCards